import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";

export async function deleteAccount() {
	const { data } = await apiAxios.post(API_ENDPOINTS.CUSTOMER_DELETION, {});
	return data.data;
}
